export const getCookie = (name: string): string | undefined => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));

  return match ? decodeURIComponent(match[1]) : undefined;
};

export const getQueryParams = (url: string) => {
  const params: Record<string, string | string[]> = {};

  const queryStringMatch = url.match(/\?(.+)/);

  if (!queryStringMatch) {
    return params;
  }

  const queryString = queryStringMatch[1];

  const regex = /([^&=]+)=([^&]*)/g;
  let match;

  while ((match = regex.exec(queryString))) {
    const key = decodeURIComponent(match[1].replace(/\+/g, " "));
    const value = decodeURIComponent(match[2].replace(/\+/g, " "));

    if (params[key]) {
      if (Array.isArray(params[key])) {
        (params[key] as string[]).push(value);
      } else {
        params[key] = [params[key] as string, value];
      }
    } else {
      params[key] = value;
    }
  }

  return params;
};
